var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.89 14.911a.914.914 0 00-.482-.658l-3.87-2.28-.033-.018a1.15 1.15 0 00-.523-.122c-.324 0-.633.123-.848.339l-1.143 1.143a.67.67 0 01-.256.116c-.013-.001-1.33-.096-3.752-2.52C5.564 8.495 5.46 7.175 5.46 7.175a.61.61 0 01.115-.276l.974-.973c.343-.344.446-.915.243-1.356L4.64.52A.89.89 0 003.844 0a.917.917 0 00-.648.278L.541 2.928A2.033 2.033 0 00.019 3.98c-.023.17-.494 4.237 5.081 9.814 4.733 4.733 8.424 5.1 9.444 5.1a2.9 2.9 0 00.371-.019 2.035 2.035 0 001.05-.52l2.654-2.653a.914.914 0 00.27-.79z",
    fill: "#FEDF00"
  })));
}

export default SvgPhone;